const _VON_ENTW_AUF_SERVER = false; // Verbindung auf den Echtserver aus der lokalen Entwicklung
export const DEBUG_FLAG = () => {
  var tmpDebugFlag = false;
  if (
    !_VON_ENTW_AUF_SERVER &&
    window.location.hostname === "localhost" &&
    (window.location.port === "3000" || window.location.port === "3001")
  )
    tmpDebugFlag = true;
  if (window.api?.send("syncToMain", "debug")) {
    tmpDebugFlag = true;
  }
  return tmpDebugFlag;
};
